import { rootActions } from "../reducers/root.slice";
import { put, select } from "typed-redux-saga";
import { selectRootState } from "../selectors";
import VectorUtils from "../lib/Vector3";
import GraphUtils from "../utils/GraphUtils";

function* rotateHeatMap(action: ReturnType<typeof rootActions.rotateHeatMap>) {
  try {
    const { graphData } = yield* select(selectRootState);

    const densityPlotData = GraphUtils.generateDensityPlotData(graphData);

    const rows = densityPlotData[0].x.length;

    for (let i = 0; i < rows; i++) {
      const rotatedVector = VectorUtils.applyEuler(
        {
          x: densityPlotData[0].x[i] as number,
          y: densityPlotData[0].y[i] as number,
          z: densityPlotData[0].z[i] as number,
        },
        {
          alpha: action.payload.x,
          beta: action.payload.y,
          gamma: action.payload.z,
        }
      );

      // if (i === 0) {
      //   console.log(
      //     "Before",
      //     densityPlotData[0].x[i],
      //     densityPlotData[0].y[i],
      //     densityPlotData[0].z[i]
      //   );
      //   console.log("After", rotatedVector.x, rotatedVector.y, rotatedVector.z);
      // }

      densityPlotData[0].x[i] = rotatedVector.x;
      densityPlotData[0].y[i] = rotatedVector.z;
      densityPlotData[0].z[i] = rotatedVector.y;
    }

    yield* put(rootActions.setDensityPlotData(densityPlotData));
  } catch (error) {}
}

export default rotateHeatMap;
